//import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
const Photos = (props) => {


}

export default withRouter(Photos)